import { render, staticRenderFns } from "./PotatoFieldFormGroups.vue?vue&type=template&id=007ab993"
import script from "./PotatoFieldFormGroups.vue?vue&type=script&lang=js"
export * from "./PotatoFieldFormGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports